module.exports = __webpack_public_path__ + "static/media/Foto 2_Mercado Las Américas_Foto Milagros Portilla.7b445467.jpg";